import { styled } from '@linaria/react';
import { fonts, primitives, semantic, size, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-800']};
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${space['space-400']};
  flex-wrap: wrap;
`;

export const TitleText = styled.h2`
  margin: 0;
  font-family: ${fonts.body};
  font-weight: ${fonts.weight.normal};
  font-size: ${fonts.size.xl};
  line-height: ${primitives.typography.lineHeight.tight};
  letter-spacing: ${primitives.typography.tracking.normal};
  color: ${semantic.text.primary};
  flex: 1;
  min-width: 0;
`;

export const ConfirmationRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${space['space-200']};
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};
`;

export const ConfirmationCheck = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${space['space-400']};
  height: ${space['space-400']};
  border-radius: ${size.radius['radius-full']};
  background: ${semantic.bg.positiveStrong};
  color: ${semantic.text.inverse};
`;

export const ItemsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-600']};

  > * + * {
    border-top: ${size.stroke['stroke-default']} solid ${semantic.border.default};
    padding-top: ${space['space-600']};
  }
`;

export const TotalRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-500']};
  border-top: ${size.stroke['stroke-default']} solid ${semantic.border.default};
  padding-top: ${space['space-600']};
`;

export const TotalLine = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  font-family: ${fonts.body};
`;

export const TotalLabel = styled.span`
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};
`;

export const SummaryLine = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  font-family: ${fonts.body};
`;

export const SummaryLabel = styled.span`
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.primary};
`;

export const DiscountAmount = styled.span`
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.positive};
`;

export const DueSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-300']};
  border-top: ${size.stroke['stroke-default']} solid ${semantic.border.default};
  padding-top: ${space['space-500']};
`;

export const DueNote = styled.p`
  margin: 0;
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.secondary};
`;

export const NoticeIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${primitives.size['size-600']};
  height: ${primitives.size['size-600']};
`;

export const NoticeAnnouncement = styled.span`
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;
